import {

  ACTIVATING_INTERCOM_REQUEST, ACTIVATING_INTERCOM_SUCCEDDED, ACTIVATING_INTERCOM_FAILED,
  UPDATING_INTERCOM_REQUEST, UPDATING_INTERCOM_SUCCEDDED, UPDATING_INTERCOM_FAILED,
} from '../../actions/actionTypes.jsx';

import { combineReducers } from 'redux';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  activation: {
    activating: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  }
};

function intercomReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIVATING_INTERCOM_REQUEST:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: true,
          error: null
        }
      })
    case ACTIVATING_INTERCOM_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: null
        }
      })
    case ACTIVATING_INTERCOM_FAILED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: action.payload
        }
      })

    case UPDATING_INTERCOM_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_INTERCOM_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_INTERCOM_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })
   
    default:
      return state
  }
}

export { intercomReducer };